module.exports = __webpack_public_path__ + "img/mapOfficeHover.eb2681c.svg";